import React, { useState, useEffect } from 'react';

export interface TextAreaProps {
    placeholder?: string;
    readOnly?: boolean;
    value?: string;
    onChange?: (value: string) => void;
    maxlength?: number;
    ['data-pw']?: string;
}

export const TextArea: React.FC<TextAreaProps> = props => {
    const [value, setValue] = useState<string | undefined>(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValue(e.target.value);
        props.onChange?.(e.target.value);
    };

    return (
        <textarea
            data-pw={props['data-pw']}
            placeholder={props.placeholder}
            readOnly={props.readOnly}
            value={value}
            onChange={onChange}
            maxLength={props.maxlength}
            className="w-full rounded-[20px] border border-[#333] px-3 py-2 text-area mb-20"
            rows={4}
        />
    );
};
